/******/ (() => { // webpackBootstrap
/* eslint-disable */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.cacheDOMElements();
    /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
    this.onSubmitBound = this.onSubmit.bind(this);
    this.handleQuickViewModal = this.handleQuickViewModal.bind(this);
    /* ===== Remove the noscript elements from the DOM (javascript is enabled) ===== */
    Array.from(this.noscriptElements).forEach(element => element.remove());
  }

  cacheDOMElements() {
    /* ===== Cache the DOM elements ===== */
    this.form = this.querySelector('form');
    this.noscriptElements = this.querySelectorAll('noscript');
    this.sectionId = this.getAttribute('data-section-id');
    this.productInformation = this.closest('product-information');
    this.cartAction = document.getElementById('PageContainer').dataset.cartAction;
    this.cartType = document.getElementById('PageContainer').dataset.cartType;
    this.cartCountIndicator = document.querySelector('[data-cart-count-indicator]');
    this.giftWrapProductId = this.getAttribute('data-gift-wrap-product-id');
    this.wethemeGlobal = document.querySelector('script#wetheme-global');
    this.translationsObject = JSON.parse(this.wethemeGlobal.textContent);
    this.qtyErrorMessage = this.querySelector('[data-qty-error-message]');

    if (window.redirect_after_add_to_cart === 'none') {
      this.cartAction = 'go_to_or_open_cart';
      this.cartType = 'drawer';
    }
  }
 
  initPurchaseTypeWatcher() {
    const customForm = document.querySelector('.add-to-cart-form');
    const mainProductForm = document.querySelector('product-form form');
    const swatchWrapper = document.querySelector('product-swatch');
    
    if (!customForm || !mainProductForm) return;
    
    const idInput = customForm.querySelector('input[name="id"]');
    const sellingPlanInput = customForm.querySelector('input[name="selling_plan"]');
    const quantityInput = customForm.querySelector('input[name="quantity"]');
    const returnToInput = customForm.querySelector('input[name="return_to"]');
    
    const subscriptionUrl = customForm.dataset.subscriptionUrl || '';
    const collectionUrl = customForm.dataset.preCheckoutCollectionUrl || '';
    const prioritize = customForm.dataset.prioritizePreCheckoutCollection === 'true';
    
    const resolveRedirect = (sellingPlanRadio, oneTimeRadio) => {
      if (prioritize) {
        return collectionUrl || '/checkout';
      }
      
      if (sellingPlanRadio && subscriptionUrl) {
        return subscriptionUrl;
      }
      
      return '/checkout';
    };
    
    // ======================
    // GET SWATCH VARIANT
    // ======================
    const getSwatchVariant = () => {
      const swatch = document.querySelector('product-swatch');
      if (!swatch) return null;
      
      const checkedInput = swatch.querySelector('input[type="radio"]:checked');
      if (!checkedInput) return null;
      
      const swatchElement = checkedInput.closest('.swatch-element');
      
      return swatchElement?.dataset.swatchVariantId || null;
    };
    
    const updateHiddenInputs = () => {
      const mainVariantInput = mainProductForm.querySelector('[name="id"]');
      const mainQuantityInput = mainProductForm.querySelector('[name="quantity"]') || document.querySelector('input.js-qty__num');
      
      const oneTimeRadio = document.querySelector('input[data-radio-type="one_time_purchase"]:checked');
      
      const sellingPlanRadio = document.querySelector('input[data-radio-type="selling_plan"]:checked');
      
      // ======================
      // VARIANT
      // ======================
      const swatchVariantId = getSwatchVariant();
      
      if (oneTimeRadio) {
        idInput.value = oneTimeRadio.dataset.variantId || '';
      } else if (swatchVariantId) {
        idInput.value = swatchVariantId;
      } else {
        idInput.value = mainVariantInput?.value || '';
      }
      
      // ======================
      // QUANTITY
      // ======================
      if (mainQuantityInput) {
        quantityInput.value = mainQuantityInput.value || 1;
      } else {
        quantityInput.value = 1;
      }
      
      // ======================
      // SELLING PLAN
      // ======================
      sellingPlanInput.value = sellingPlanRadio?.dataset.sellingPlanId || '';
      
      // ======================
      // REDIRECT
      // ======================
      returnToInput.value = resolveRedirect(sellingPlanRadio, oneTimeRadio);
    };
    
    // ======================
    // SUBSCRIPTION WATCHER
    // ======================
    setTimeout(() => {
      const container = document.querySelector('.shopify_subscriptions_fieldset');
      if (!container) return;
      
      this.replaceUnitText(container);
      
      container.addEventListener('click', () => {
        this.replaceUnitText(container);
        updateHiddenInputs();
        this.syncQtyOnVariant();
      });
    }, 600);
    
    // ======================
    // SWATCH WATCHER
    // ======================
    if (swatchWrapper) {
      swatchWrapper.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) {
          updateHiddenInputs();
          this.syncQtyOnVariant();
        }
      });
    }
    
    // ======================
    // QUANTITY WATCHER
    // ======================
    const qtyInput = document.querySelector('input.js-qty__num');
    if (qtyInput) {
      qtyInput.addEventListener('change', () => {
        updateHiddenInputs();
      });
    }
    
    // ======================
    // INITIAL RUN
    // ======================
    setTimeout(updateHiddenInputs, 700);
    
    // ======================
    // SECTION RELOAD SUPPORT
    // ======================
    document.addEventListener('shopify:section:load', () => {
      setTimeout(updateHiddenInputs, 500);
    });
  }
  
  syncQtyOnVariant() {
    const qtyInput = document.querySelector('input.js-qty__num');
    if (qtyInput) qtyInput.value = 1;
  }
  
  replaceUnitText(container) {
    const UnitContainer = container.querySelector('.price-per-items');
    if (!UnitContainer || !this.translationsObject?.translations?.unit) return;
    
    const unit = this.translationsObject.translations.unit;
    
    const pluralEl = UnitContainer.querySelector('.total_measure');
    if (pluralEl) {
      pluralEl.textContent = pluralEl.textContent.replace(/Portionen/g, unit);
    }
    
    UnitContainer.innerHTML = UnitContainer.innerHTML.replace(/\/\s*Portion(?!en)/g, `/ ${unit}`);
  }

  connectedCallback() {
    /* ===== Set the initial state of the add to cart button ===== */
    if (!this.form) return;
    this.attachEventListeners();
    this.initPurchaseTypeWatcher();
  }

  attachEventListeners() {
    /* ===== Attach the event listeners to the DOM elements ===== */
    this.form.addEventListener('submit', this.onSubmitBound);
  }

  onSubmit(event) {
    /* ===== Handle the form submission ===== */
    event.preventDefault();
    this.prepareForSubmission();
  }

  prepareForSubmission() {
    /* ===== Prepare the form for submission ===== */
    this.cacheSubmissionElements();
    if (!this.checkRequiredInputs()) return;
    this.disableBlankInputs();
    // If the form is valid, proceed with the submission
    this.showLoadingState();
    this.addItemsToCart();
  }

  cacheSubmissionElements() {
    /* ===== Cache the elements needed for form submission ===== */
    this.loadingIcon = this.form.querySelector('[data-loading-icon]');
    this.addToCartText = this.form.querySelector('[data-add-to-cart-text]');
    this.addedText = this.form.querySelector('[data-cart-added-text]');
    this.quantityInput = this.form.querySelector('[name="quantity"]');
    this.quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) || 1 : 1;
  }

  disableBlankInputs() {
    // Select all input and textarea elements
    const elements = this.productInformation.querySelectorAll('input, textarea');
    this.blankElements = [];

    elements.forEach((element) => {
      // Check if the element has no value
      if (!element.value) {
        // Temporarily disable the element so that it is not included in the form submission
        element.disabled = true;
        this.blankElements.push(element);
      }
    });
  }

  enableBlankInputs() {
    // Enable the blank elements that were disabled
    this.blankElements.forEach((element) => {
      element.disabled = false;
    });
    this.blankElements = [];
  }

  fetchConfig(type = 'json') {
    /* ===== Create the fetch configuration object ===== */
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  checkRequiredInputs() {
    /* ===== Check if the required inputs have been filled out ===== */
    const requiredInputs = Array.from(this.productInformation.querySelectorAll('[required]:not(:disabled)'));
    this.clearErrorMessages();

    const invalidInputs = requiredInputs.filter(input => {
      if (input.type === 'checkbox') {
        return !input.checked;
      } else {
        return !input.value.trim();
      }
    });

    invalidInputs.forEach(input => this.applyErrorMessage(input));
    return invalidInputs.length === 0;
  }

  clearErrorMessages() {
    /* ===== Clear the error messages from the form ===== */
    this.productInformation.querySelectorAll('.required-field-error').forEach(error => error.remove());
  }

  applyErrorMessage(input) {
    /* ===== Apply the error message to the input element if the required input is empty ===== */
    if (!input) return;
    const inputId = input.id;
    const buttonWrapper = this.querySelector('.paymentButtonsWrapper');
    const errorContainer = input.closest('.input-wrapper')?.querySelector('.input-error-container');
    const errorMessage = input.hasAttribute('custom-dropdown-input') ? this.translationsObject.translations.required_dropdown_error : input.type === 'file' ? this.translationsObject.translations.required_upload_error : input.type === 'checkbox' ? this.translationsObject.translations.required_checkbox_error : this.translationsObject.translations.required_input_error;
    const errorElement = `<span id="${inputId}" class="required-field-error errors" style="display: block;">${errorMessage}</span>`;
    const submitErrorMessage = input.type == 'file' ? input.closest('file-upload')?.dataset.errorMessage : input.dataset.errorMessage;
    const submitErrorElement = `<span id="${inputId}Submit" class="required-field-error errors" style="display: block;" role="alert">${submitErrorMessage}</span>`;
    errorContainer ? errorContainer.innerHTML = errorElement : input.insertAdjacentHTML('beforebegin', errorElement);
    if (buttonWrapper) buttonWrapper.insertAdjacentHTML('beforebegin', submitErrorElement);
    input.focus();

    // If the input has an error message, add an 'input' event listener to remove the error message
    if (input.type == 'file') return;
    input.addEventListener('input', () => {
      this.productInformation.querySelector(`#${inputId}.required-field-error`)?.remove();
      this.querySelector(`#${inputId}Submit.required-field-error`)?.remove();
    }, { once: true });
  }

  giftWrapEnabled() {
    /* ===== Determine if the gift wrap product is enabled ===== */
    return !!this.productInformation.querySelector('[name="properties[Gift wrap]"]')?.checked && this.giftWrapProductId !== '';
  }

  async addItemsToCart() {
    /* ===== Add the item(s) to the cart ===== */
    try {
      // Add the main product to the cart
      const mainProductAdded = await this.addProductToCart(routes.cart_add_url, this.fetchConfigWithBody());
      if (mainProductAdded && this.giftWrapEnabled()) {
        // Add the gift wrap product to the cart
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(this.giftWrapProductId, this.quantity));
      }
      // Process the response
      this.processResponse(mainProductAdded);
    } catch (error) {
      console.error(`Error adding item(s) to cart: ${error.description || error.message}`);
    }
  }

  async addProductToCart(url, config) {
    /* ===== Add the product to the cart ===== */
    const response = await fetch(url, config);
    if (response.ok) {
      // Update cart drawer
      if (this.cartType === 'drawer') {
        const responseJson = await response.json();
        this.updateCartDrawer(responseJson);
      }
    } else {
      console.error(`Error adding item to cart: ${response.description || response.statusText}`);
    }
    return response;
  }

  additionalProductConfig(productId, quantity) {
    /* ===== Create the configuration object for the additional product(s) to be added to the cart ===== */
    const additionalItemPayload = { items: [{ id: productId, quantity: quantity }] };
    if (this.cartType === 'drawer') {
      additionalItemPayload['sections'] = 'cart-drawer';
    }
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(additionalItemPayload)
    };
  }

  updateCartDrawer(responseJson) {
    eventBus.emit('update:cart:drawer', responseJson);
  }

  async getCart() {
    /* ===== Fetch the cart information ===== */
    try {
      const response = await fetch(`${routes.cart_url}?view=compare`);
      return await response.json();
    } catch (error) {
      console.error(`Error fetching cart: ${error.description || error.message}`);
    }
  }

  updateCartCountIndicator() {
    /* ===== Update the cart count indicator ===== */
    if (!this.cartCountIndicator) return;
    this.getCart().then(cart => window.wetheme.updateCartCount(cart));
  }

  fetchConfigWithBody() {
    /* ===== Create the fetch configuration object with the form data as the body ===== */
    const config = this.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = this.addSectionsParam(new FormData(this.form));
    return config;
  }

  addSectionsParam(formData) {
    /* ===== Add the sections parameter to the form data for cart drawer rendering ===== */
    if (this.cartType === 'drawer') {
      formData.append('sections', 'cart-drawer');
    }
    return formData;
  }

  processResponse(response) {
    /* ===== Process the response from the server ===== */
    if (response.ok) {
      return response.json().then(data => {
        // Check if the response indicates a blocked action due to active subscription
        if (data?.blocked === true && data?.reason === "active_subscription") {
          this.hideLoadingState();
          // Stop further processing and do not redirect to checkout
          return "";
        }

        this.hideLoadingState();
        // Redirect to checkout only if not blocked
        window.location.href = '/checkout';
        console.log('Redirecting to checkout...',window.redirect_after_add_to_cart);
        alert(11);
        return "";
      }).catch(() => {
        this.hideLoadingState();
        return "";
      });
    }

    // Handle the case where the product is out of stock or blocked (e.g., status 403)
    if (response.status === 422 || response.status === 403) {
      window.eventBus.emit('render:cart:drawer');
      this.hideLoadingState();
      if (this.qtyErrorMessage) this.qtyErrorMessage.classList.remove('hidden');
      return "";
    }

    // Emit the cart:added event
    eventBus.emit('cart:added', { sectionId: this.sectionId });

    // Handle quick view modal if we're in one
    this.handleQuickViewModal();

    // Re-enable the blank inputs
    this.enableBlankInputs();
  }

  openCartDrawer() {
    /* ===== Open the cart drawer ===== */
    eventBus.emit('open:cart:drawer', { scrollToTop: true });
  }

  handleQuickViewModal() {
    /* ===== Close the quick view modal if product was added from quick view ===== */
    if (this.closest('[data-quick-view-product]')) {
      const closeModal = () => {
        const isModalOpen = document.body.classList.contains('theme-modal-open');
        if (isModalOpen) {
          eventBus.emit('theme:modal:hide');
        }
      };

      if (this.cartAction === 'show_added_message' && this.addedText) {
        setTimeout(closeModal, 1500); // Allows the 'added' message to display before closing the modal
      } else {
        closeModal();
      }
    }
  }

  showLoadingState() {
    /* ===== Show the loading state of the add to cart button ===== */
    this.toggleElements(this.addToCartText, false);
    this.toggleElements(this.loadingIcon, true, 'hidden');
    this.toggleAddButton(true);
  }

  hideLoadingState() {
    /* ===== Hide the loading state of the add to cart button ===== */
    this.toggleElements(this.loadingIcon, false, 'hidden');
    this.toggleCartActionDisplay();
  }

  toggleCartActionDisplay() {
    // alert(this.cartAction)
     /* ===== Toggle the cart action display based on the selected action ===== */
    if (this.cartAction === 'show_added_message' && this.addedText) {
      // Show the added text message and update the cart count indicator
      this.addedText.style.display = 'block';
      setTimeout(() => {
        this.toggleAddToCartText(true);
        this.toggleAddButton(false);
        this.updateCartCountIndicator();
      }, 2000);
    } else if (this.cartType === 'drawer' && this.cartAction === 'go_to_or_open_cart') {
      // Open the cart drawer
      this.toggleAddToCartText(true);
      this.openCartDrawer();
      this.toggleAddButton(false);
      this.updateCartCountIndicator();
    } else if(this.cartAction === 'go_to_checkout'){
      //this.toggleAddToCartText(true);
      // this.openCartDrawer();
      window.location.href = '/checkout';
      //this.toggleAddButton(false);
      //this.updateCartCountIndicator();
    }
    else {
      // Redirect to the cart page
      this.toggleAddToCartText(true);
      this.toggleAddButton(false);
      window.location = window.routes.cart_url;
    }
  }

  toggleAddToCartText(show) {
    /* ===== Toggle the add to cart text and the added text message ===== */
    // Show the added text message and hide the add to cart text
    if (this.addedText) this.addedText.style.display = show ? 'none' : 'block';
    // Show the add to cart text and hide the added text message
    if (this.addToCartText) this.addToCartText.style.display = show ? 'block' : 'none';
  }

  toggleElements(element, show, className) {
    /* ===== Toggle the display of the element based on the show value ===== */
    if (!element) return;
    if (className) {
      show ? element.classList.remove(className) : element.classList.add(className);
    } else {
      element.style.display = show ? 'block' : 'none';
    }
  }

  toggleAddButton(disable = true) {
    /* ===== Toggle the state of the add to cart button ===== */
    const addButtons = this.querySelectorAll('[name="add"], .product--one-time-btn');
    if (!addButtons.length) return;

    addButtons.forEach(button => {
      button.disabled = disable;
    });
  }

  disconnectedCallback() {
    /* ===== Remove the event listeners when the element is removed from the DOM ===== */
    this.form.removeEventListener('submit', this.onSubmitBound);
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}

/* ===== Extra Variant Block Sync (SAFE) ===== */
document.addEventListener('change', (event) => {
  const radio = event.target.closest(
    'input[data-radio-type="one_time_purchase"][data-variant-id]'
  );
  if (!radio) return;

  const form = radio.closest('product-information')?.querySelector('form');
  if (!form) return;

  const variantInput = form.querySelector('input[name="id"]');
  if (!variantInput) return;

  variantInput.value = radio.dataset.variantId;
  variantInput.dispatchEvent(new Event('change', { bubbles: true }));
});

/******/ })();